import routes from './routes';
import SetRoutes from 'components/setRoutes';

const StockPickingPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default StockPickingPages;
